import React from 'react';

import {SimpleActionButton} from 'components/form/components';

interface IShowAsideButtonProps {
    handleMenuCollapse: () => void;
}

export const ShowAsideButton = ({handleMenuCollapse}: IShowAsideButtonProps) => (
    <SimpleActionButton
        key={1}
        type="primary"
        onClick={handleMenuCollapse}
        title="Оглавление"
        icon="BurgerIcon"
    />
);
